/* eslint-disable react/jsx-handler-names */
import React from 'react'

import { NavMenuButton } from './NavMenuButton/NavMenuButton'
import { DropdownTrigger } from '../DropdownMenu/DropdownTrigger'

import { sendTealiumClickEvent, ClickEventOptions } from '../../utils/sendTealiumEvent'

export type NavItem = {
  label: string;
  active?: boolean;
  badge?: React.ReactNode;
  onClick?: () => void;
  dropdown?: React.ReactNode;
  href?: string;
  icon?: string;
  hasAccordionCaret?: boolean;
  locationUrls?: Array<string>;
  gaText?: string;
};

export interface NavMenuProps {
  analyticsCategory: string;
  className?: string;
  items: NavItem[];
  ariaLabel: string;
  isLoggedIn: boolean;
}

export const NavMenu: React.FC<NavMenuProps> = ({ analyticsCategory, className, items, ariaLabel, isLoggedIn }) => {
  return (
    <nav className={`${className} ch-c-navmenu`} aria-label={`${ariaLabel}`}>
      {items.map(({ hasAccordionCaret = false, locationUrls = [], ...item }, index) => {
        const handleClickEvent = () => {
          const options: ClickEventOptions = {
            logged_in: isLoggedIn,
            text: item.gaText || item.label,
            target_location: item.href,
            category: analyticsCategory
          }

          sendTealiumClickEvent(options)
        }

        return (
          item.dropdown ? (
            <DropdownTrigger key={`${index}-${item.label}`} onClick={handleClickEvent} dropdown={item.dropdown}>
              <NavMenuButton label={item.label} hasAccordionCaret={hasAccordionCaret} icon={item?.icon} locationUrls={locationUrls} badge={item.badge} />
            </DropdownTrigger>
          )
            : (
              <NavMenuButton key={`${index}-${item.label}`} onClick={handleClickEvent} href={item.href} active={item.active} label={item?.label} icon={item?.icon} locationUrls={locationUrls} badge={item.badge} />
            )
        )
      })}
    </nav>
  )
}
